function closest(target, selector) {
  return target && typeof target.closest === 'function' ? target.closest(selector) : null;
}

function matches(target, selector) {
  return target && typeof target.matches === 'function' && target.matches(selector);
}

function closeSizeGuide(modal) {
  if (modal?.open && typeof modal.close === 'function') {
    modal.close();
  }
}

const boundQuickAddModals = new WeakSet();

export function handleQuickAddSizeGuideClick(event, root = document) {
  handleSizeGuideClick(event, root);
  // The guide sits beside the outer dialog inside Quick Add. Do not let its
  // clicks reach the outer dialog's outside-click handler.
  event.stopPropagation?.();
}

export function handleQuickAddSizeGuideKeydown(event) {
  if (event.key !== 'Escape') return;
  event.preventDefault?.();
  event.stopPropagation?.();
  closeSizeGuide(event.currentTarget);
}

export function placeQuickAddSizeGuideModals(quickAddDialog, productGrid) {
  if (!quickAddDialog || !productGrid) return;

  const activeModals = Array.from(productGrid.querySelectorAll('.co-size-guide-modal'));
  const existingModals = Array.from(quickAddDialog.children).filter((child) =>
    child.matches?.('.co-size-guide-modal'),
  );

  for (const modal of existingModals) {
    modal.remove();
  }

  for (const modal of activeModals) {
    quickAddDialog.appendChild(modal);
    if (!boundQuickAddModals.has(modal)) {
      modal.addEventListener('click', handleQuickAddSizeGuideClick);
      modal.addEventListener('keydown', handleQuickAddSizeGuideKeydown);
      boundQuickAddModals.add(modal);
    }
  }
}

export function handleSizeGuideClick(event, root = document) {
  const target = event.target;
  const closeButton = closest(target, '[data-modal-close]');

  if (closeButton) {
    closeSizeGuide(closest(closeButton, '.co-size-guide-modal'));
    return;
  }

  const trigger = closest(target, '[data-size-guide-trigger]');
  if (trigger) {
    event.preventDefault?.();
    const modalId = `co-size-guide-modal-${trigger.dataset.sizeGuideTrigger}`;
    const quickAddDialog = closest(trigger, 'quick-add-dialog');
    const modal = quickAddDialog?.querySelector(`#${modalId}`) || root.getElementById(modalId);

    if (modal && typeof modal.showModal === 'function') {
      if (!modal.open) modal.showModal();
      modal.querySelector('[data-modal-close]')?.focus();
    }
    return;
  }

  if (matches(target, '.co-size-guide-modal[data-close-on-backdrop]')) {
    closeSizeGuide(target);
  }
}

if (typeof document !== 'undefined') {
  document.addEventListener('click', handleSizeGuideClick);
}
